const PRODUCT_TYPE_CD = {
  PRODUCT_SEEDING_PASS                    :10,
  PRODUCT_SEEDING_PASS_CANCEL             :11,
  PRODUCT_SEEDING_PASS_RECOVER            :12,
  PRODUCT_SEEDING                         :13,
  PRODUCT_SEEDING_FIRST                   :14,
  PRODUCT_SEEDING_COMMISSION              :15,
  PRODUCT_SEEDING_BEAUTY_SINGLE           :16,
  PRODUCT_SEEDING_BEAUTY_YEARLY           :17,
  PRODUCT_SEEDING_BEAUTY_COMMISSION_ONLY  :18,
  PRODUCT_SEEDING_INSPECTION_FEE          :19,
  PRODUCT_SEEDING_VIDEO_CLEAN             :40,
  PRODUCT_SEEDING_COMMISSION_INCREASE     :50,

  PRODUCT_RENTAL_PASS                     :20,
  PRODUCT_RENTAL_PAID_SERVICE_CANCEL      :21,
  PRODUCT_RENTAL_BY_MODEL                 :22,

  PRODUCT_SNS_PASS                        :30,
  PRODUCT_SNS_PASS_CANCEL                 :31,
  PRODUCT_SNS_PASS_RECOVER                :32,
  PRODUCT_SNS_INSTALL                     :33,

  PRODUCT_ETC                             :99,
}

const BRAND_PAYMENTS = {
  PRODUCT_TYPE_CD,
}

export default BRAND_PAYMENTS
